<template>
  <div>
    <div class="support">
      <div class="intro">
        <div class="left">
          <img class="line" src="../assets/index/line.png" alt="" />
          <div class="title">品牌支持</div>
        </div>
      </div>
    </div>
    <div class="img"><img :src="`${bannerimg}`" alt="" /></div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="sort">
          <img :src="item.image" alt="" />
        </div>
        <div class="text">
          <div class="title">{{ item.title }}</div>
          <div class="desc" v-html="item.desc"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { supportBanner, supportList } from "../api/request";

export default {
  name: "Support",
  data() {
    return {
      bannerimg: null,
      list: [],
    };
  },
  mounted() {
    supportBanner().then((res) => {
      if (res.data.code == 1) {
        this.bannerimg = res.data.data.bannner;
      }
    });
    supportList().then((res) => {
      if (res.data.code == 1) {
        // console.log(res.data.data);
        this.list = res.data.data;
      }
    });
  },
};
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #004c31 !important;
}
</style>
<style scoped lang="less">
.support {
  padding-top: 60px;
  width: 1280px;
  margin: 0 auto;
  font-family: 微软雅黑, MicrosoftYaHei;
  .intro {
    width: 1280px;
    margin: 0 auto 42px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .left {
      text-align: left;
    }
    .line {
      width: 90px;
      height: 8px;
    }
    .title {
      font-size: 42px;
      font-family: 微软雅黑, MicrosoftYaHei;
      font-weight: bold;
      color: #004c31;
      margin-top: 38px;
    }
    .subTitle {
      margin-top: 24px;
      font-size: 24px;
      font-family: 微软雅黑, MicrosoftYaHei;
      font-weight: 400;
      color: #004c31;
    }
  }
}
.img {
  width: 100%;
  height: auto;
  img {
    width: 100%;
    height: auto;
  }
}
.list {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-bottom: 100px;
  .item {
    margin-top: 32px;
    display: flex;
    align-items: flex-start;
    .sort {
      width: 65px;
      height: 65px;
      img {
        width: 65px;
        height: 65px;
      }
    }
    .text {
      margin-top: 18px;
      margin-left: 60px;
      width: 840px;
      text-align: left;
      .title {
        padding-bottom: 20px;
        border-bottom: 1px dotted #d5d5d5;
        font-size: 24px;
        font-weight: bold;
        color: #004c31;
      }
      .desc {
        font-size: 20px;
        color: #6c7a77;
        margin-top: 32px;
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .support {
    padding-top: 60px;
    width: 1280px;
    margin: 0 auto;
    font-family: 微软雅黑, MicrosoftYaHei;
    .intro {
      width: 1280px;
      margin: 0 auto 42px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .left {
        text-align: left;
      }
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
      .title {
        font-size: 42 * 2px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: bold;
        color: #004c31;
        margin-top: 38 * 2px;
      }
      .subTitle {
        margin-top: 24 * 2px;
        font-size: 24 * 2px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: 400;
        color: #004c31;
      }
    }
  }
  .list {
    width: 1280px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-bottom: 100px;
    .item {
      margin: 32 * 2px auto 0;
      display: flex;
      align-items: flex-start;
      .sort {
        width: 65 * 2px;
        height: 65 * 2px;
        img {
          width: 65 * 2px;
          height: 65 * 2px;
        }
      }
      .text {
        margin-top: 18 * 2px;
        margin-left: 60px;
        width: 840px;
        text-align: left;
        .title {
          padding-bottom: 20px;
          border-bottom: 1px dotted #d5d5d5;
          font-size: 24 * 2px;
          font-weight: bold;
          color: #004c31;
        }
        .desc {
          font-size: 20 * 2px;
          color: #6c7a77;
          margin-top: 32 * 2px;
        }
      }
    }
  }
}
</style>
